import { Stack } from '@mui/material';

import { ErrorLoadingPage, Loading } from '@hapvida/hapvida-core-components';

import { organizeFilesByType } from '@utils';

import { RedirectAlert } from '../../components';
import { BillDetailsCard, CopartReportCard } from './components';
import { useBillState } from './hooks';
import { BillTypeEnum } from '../../constants/billtypeEnum';

export function BillLayout() {
  const {
    refreshBillStates,
    billDetailsState,
    coparticipationReportRequestState,
  } = useBillState();

  if (billDetailsState?.isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }

  const hasError = billDetailsState?.isError;

  if (hasError) {
    return <ErrorLoadingPage onReloadClick={refreshBillStates} />;
  }

  const reportFiles = organizeFilesByType([
    ...(coparticipationReportRequestState.data &&
    Array.isArray(coparticipationReportRequestState.data[0]?.path)
      ? coparticipationReportRequestState.data[0].path
      : []),
  ]);

  const isCarnetComplement =
    billDetailsState.data?.billType === BillTypeEnum.CARNET_COMPLEMENT;

  return (
    <Stack paddingY={3} paddingX={1}>
      <RedirectAlert />
      <BillDetailsCard bill={billDetailsState.data} reportFiles={reportFiles} />
      {isCarnetComplement && (
        <CopartReportCard
          reports={reportFiles}
          remittenceCode={billDetailsState.data.remittence}
          personNumber={billDetailsState.data.personNumber}
        />
      )}
    </Stack>
  );
}
